import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import injectStyles from 'src/common/utils/injectStyles';
import { optimiseImage } from 'src/common/utils/prismic-image';
import './SpriteAnimate.scss';

const animationIterationCount = 2;
let instanceCount = 0;

class SpriteAnimate extends Component {
  static propTypes = {
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    numberOfFrames: PropTypes.number.isRequired,
    src: PropTypes.string.isRequired,
  };

  state = {
    isHovered: false,
  };

  constructor(props) {
    super(props);
    this.spriteName = `SpriteAnimate-${instanceCount++}`;
  }

  componentDidMount() {
    const keyframe = `
      @keyframes ${this.spriteName} {
        from {
          background-position: 0 0;
        }
        to {
          background-position: 0 ${(this.props.height - 140) * -1}px;
        }
      }
    `;
    injectStyles(keyframe);
  }

  handleMouseEnter = () => {
    this.setState(
      () => ({
        isHovered: true,
      }),
      () => {
        setTimeout(() => {
          this.setState(() => ({
            isHovered: false,
          }));
        }, 100 * animationIterationCount * this.props.numberOfFrames);
      }
    );
  };

  render() {
    return (
      <div
        onMouseEnter={this.handleMouseEnter}
        className={cx('sprite-animate', { 'sprite-animate-active': this.state.isHovered })}
        style={{
          animationName: this.state.isHovered ? this.spriteName : null,
          animationTimingFunction: `steps(${this.props.numberOfFrames}, end)`,
          animationDuration: `${this.props.numberOfFrames * 0.1}s`,
          height: this.props.width / 2,
          width: this.props.width / 2,
          backgroundImage: `url(${optimiseImage(this.props.src)})`,
          animationIterationCount: `${this.state.isHovered ? animationIterationCount : null}`,
        }}
      />
    );
  }
}

export default SpriteAnimate;



// WEBPACK FOOTER //
// ./src/client/js/view/components/SpriteAnimate/SpriteAnimate.js